import { formatMoney } from "helpers/money";
import { formatInvoiceCurrencyAmount, paymentCurrency } from "helpers/invoiceCurrency";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { clientInvoiceRefundRows } from './clientInvoicePaymentRows';
const InvoiceRefundHistory = ({payments, currency = ""}) => <>{clientInvoiceRefundRows(payments).map((payment,index)=><li className="border-top my-3 pt-3" key={payment.id || index}>
 <div className="row gx-1 justify-content-between">
  <h6 className="mb-0 col-10"><strong>REFUNDED</strong> By {payment.paidby} {payment.created_at ? moment(payment.created_at).format('DD/MM/YYYY') : ''}</h6>
  <h6 className="mb-0 col-2 text-end">{paymentCurrency(payment, currency) ? formatMoney(payment.amount, paymentCurrency(payment, currency)) : formatInvoiceCurrencyAmount(payment.amount, "")}</h6>
 </div>
</li>)}</>;
InvoiceRefundHistory.propTypes = { currency: PropTypes.string, payments: PropTypes.arrayOf(PropTypes.object) };
export default InvoiceRefundHistory;
